import { useClubContext } from '../contexts/ClubContext'
import { ProductLayout } from '../types/Product'

export type showSectionFilter = 'ambos' | 'isLoggedIn' | 'notLoggedIn'

export type showSectionVariables = {
  club: showSectionFilter
  cartonista: showSectionFilter
  shelfLayout?: ProductLayout
}

export const defaultVisibilityConfig: showSectionVariables = {
  club: 'ambos',
  cartonista: 'ambos',
}

export function showSection(params: showSectionVariables): boolean {
  const { club, cartonista } = params
  const { isClubClient, userInfos } = useClubContext()

  let isClubValid = false
  let isCartonistaValid = false

  if (
    club === 'ambos' ||
    (club === 'isLoggedIn' && isClubClient) ||
    (club === 'notLoggedIn' && !isClubClient)
  ) {
    isClubValid = true
  }

  if (
    cartonista === 'ambos' ||
    (cartonista === 'isLoggedIn' && userInfos?.isCartonist) ||
    (cartonista === 'notLoggedIn' && !userInfos?.isCartonist)
  ) {
    isCartonistaValid = true
  }

  return isClubValid && isCartonistaValid
}
